import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-rate-input',
  templateUrl: './rate-input.component.html',
  styleUrls: ['./rate-input.component.scss'],
})
export class RateInputComponent implements OnInit {
  @Input() rate: number;
  @Output() rateChanged = new EventEmitter<number>();

  rateArray: boolean[] = [];
  rateMin = 1;
  rateMax = 5;
  rateBackup = 0;

  constructor() {}

  public ngOnInit() {
    this.rateBackup = this.rate;
    this.generateRateArray();
  }

  public trackByFn(i: number, el: boolean) {
    return el ? `${i}-${el}` : null;
  }

  public setRate(rateValue: number): void {
    if (this.rateBackup !== rateValue) {
      this.rate = rateValue;
      this.rateBackup = rateValue;
      this.generateRateArray();
      this.rateChanged.emit(rateValue);
    }
  }

  private generateRateArray() {
    this.rateArray = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= this.rate) {
        this.rateArray.push(true);
      } else {
        this.rateArray.push(false);
      }
    }
  }
}
